<script lang="ts">
import ClubBanner from '@/components/banners/ClubBanner.vue'
import PartnerBanner from '@/components/banners/PartnerBanner.vue'
import QuickLinksCard from '@/components/cards/QuickLinksCard.vue'
import BannerLayoutProvider from '@/components/sections/Banner/BannerLayoutProvider.vue'
import GamesSection from '@/components/sections/Homepage/GamesSection.vue'
import MembersPrizesSection from '@/components/sections/Homepage/MembersPrizesSection.vue'
import LatestWinnersSection from '@/components/sections/LatestWinnersSection.vue'
import ProductOverviewSection from '@/components/sections/ProductOverviewSection.vue'
import { useTailwind } from '@/plugins/useTailwind'
import FaqView from '@/views/faq/FaqView.vue'
import { defineComponent } from 'vue'

/**
 * The "Home" brand page - this is temporary until we find a better pattern
 */
export default defineComponent({
  components: {
    BannerLayoutProvider,
    ClubBanner,
    FaqView,
    GamesSection,
    LatestWinnersSection,
    MembersPrizesSection,
    PartnerBanner,
    ProductOverviewSection,
    QuickLinksCard,
  },
  setup() {
    const { breakpoints } = useTailwind()

    return {
      breakpoints,
    }
  },
  data() {
    return {
      columnsPerRow: 4,
      resizeObserver: null as ResizeObserver | null,
    }
  },
  mounted() {
    this.setupResizeObserver()
  },
  beforeUnmount() {
    this.resizeObserver?.disconnect()
  },
  methods: {
    setupResizeObserver() {
      const mainContainer = document.querySelector('main')
      if (!mainContainer) {
        return
      }

      this.resizeObserver = new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width
        if (width >= this.breakpoints.lg) {
          this.columnsPerRow = 4
        } else if (width >= this.breakpoints.md) {
          this.columnsPerRow = 3
        } else {
          this.columnsPerRow = 2
        }
      })
      this.resizeObserver.observe(mainContainer)
    },
  },
})
</script>

<template>
  <BannerLayoutProvider />

  <QuickLinksCard />

  <LatestWinnersSection />

  <ClubBanner />

  <!-- Instant Prizes -->
  <GamesSection :columns-per-row="columnsPerRow" />

  <!-- Good Fanz Prizes -->
  <MembersPrizesSection :columns-per-row="columnsPerRow" />

  <ProductOverviewSection id="product-overview-section" />

  <PlansSection />

  <PartnerBanner />

  <FaqView :show-breadcrumb="false" />
</template>
